import React, { FC, useContext } from "react";
import { useSelector } from "react-redux";

import { FeatureCardContext } from "./FeatureCardContext";
import { getProjectPage } from "../../../../ducks/project/selectors";
import { getHeaderTemplate } from "../../utils/getHeaderTemplate";
import { getPreviousFeatureReference, getSourceLayerInfo } from "../../../../ducks/showFeature/selectors";
import { renderElement } from "../../utils/renderElement";
import { useTempLayer } from "../../../../hooks/layer/useTempLayer";

export const FeatureCardHeader: FC = () => {
  const { layerInfo, attributes, handBookReference, expandedContainers, selectedTabId, setSelectedTabId } =
    useContext(FeatureCardContext);
  const previousFeatureReference = useSelector(getPreviousFeatureReference);
  const sourceLayerInfo = useSelector(getSourceLayerInfo);
  const page = useSelector(getProjectPage);
  const { tempLayerSourceName, getTempLayerInfo } = useTempLayer();
  const { configuration } = getTempLayerInfo(tempLayerSourceName) || sourceLayerInfo || layerInfo || {};
  const config = configuration?.cardConfiguration;

  const HeaderTemplate = getHeaderTemplate(config?.header?.templateName);

  return (
    <HeaderTemplate
      config={config?.header}
      attributes={attributes}
      layerInfo={layerInfo}
      isRow={!!handBookReference || !!previousFeatureReference}
      renderElement={renderElement({
        config,
        elementConfig: config?.header,
        attributes,
        layerInfo,
        expandedContainers,
        selectedTabId,
        setSelectedTabId,
        page,
      })}
    />
  );
};
